import reducer, { FullArchiveDownloadObsrecState } from "./reducers";
import * as fullArchiveDownloadObsrecOperations from "./operations";
export {
  fullArchiveDownloadObsrecOperations,
  FullArchiveDownloadObsrecState
};

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/modules/fullArchiveDownloadObsrec/index.ts